import {
  DialogDescription,
  DialogHeaderClose,
  DialogTitle,
} from "@nasam/ui";

/**
 * The primary-colored header both GPRS popups share (Send Command, Command
 * Details) -- same markup as SensorFormDialogHeader. Full-bleed against the
 * dialog's edges, so the DialogContent rendering it drops its own padding
 * (`p-0`, `showCloseButton={false}`).
 */
export function GprsDialogHeader({
  title,
  subtitle,
  closeLabel,
}: {
  readonly title: string;
  readonly subtitle: string;
  readonly closeLabel: string;
}) {
  return (
    <div className="flex items-start justify-between gap-2 rounded-t-lg bg-primary-button-background px-4 py-3">
      <div className="space-y-0.5">
        <DialogTitle className="text-primary-button-text">{title}</DialogTitle>
        <DialogDescription className="text-body-s-r text-primary-button-text/80">
          {subtitle}
        </DialogDescription>
      </div>
      <DialogHeaderClose label={closeLabel} />
    </div>
  );
}
